<template>
  <BaseLayout
    :searchPlaceholder="placeHolderText"
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    @child-data-state-mount="handle_external_mount"
  >
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #visit id
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        In Department
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Ticket Number
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Payment Method
      </th>

      <th class="text-secondary opacity-7"></th>
    </template>

    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div></div>
            <div class="d-flex flex-column justify-content-center">
              <h6 style="color: black" class="mb-0 text-sm">
                {{ user.name }}
              </h6>

              <p class="text-xs text-secondary mb-0">
                {{ user.phone == null ? "" : user.phone }}
              </p>
              <p class="text-xs text-secondary mb-0">
                {{ user.email == null ? "" : user.email }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td class="align-middle text-sm">
          <p class="text-xs font-weight-bold mb-0">
            {{
              user.department_name == null
                ? "--"
                : user.department_name + " - " + user.department_code_id
            }}
          </p>
          <p class="text-xs text-secondary mb-0">
            {{
              user.department_description == null
                ? "--"
                : user.department_description
            }}
          </p>
        </td>
        <td class="align-middle text-center text-sm">
          <soft-badge
            :style="{
              backgroundColor: 'beige',
              color: 'black',
              paddingLeft: '1em',
              paddingRight: '1em',
              borderRadius: '0.5em',
            }"
            color="success"
            variant="gradient"
            size="sm"
          >
            {{ user.ticket_id }}
          </soft-badge>
        </td>
        <td class="align-middle text-center text-sm">
          <span
            :style="
              user.payment_method == 2
                ? {
                    backgroundColor: 'wheat',
                    color: 'black',
                    paddingLeft: '1em',
                    paddingRight: '1em',
                    borderRadius: '0.5em',
                  }
                : {
                    backgroundColor: '#80e5ff',
                    color: 'black',
                    paddingLeft: '1em',
                    paddingRight: '1em',
                    borderRadius: '0.5em',
                  }
            "
          >
            {{
              user.payment_method == 2
                ? user.insurance_company == null
                  ? "Invoice"
                  : "Insurance"
                : "Cash"
            }}
          </span>
        </td>
        <td class="align-middle">
          <!-- <span
            style="
              background-color: pink;
              border-radius: 5px;
              color: black;
              padding-left: 3px;
              padding-right: 3px;
            "
            v-if="
              user.consultation_is_paid == null && user.payment_method == '1'
            "
          >
            <span style="color: red">!!</span>Consultation
            Payment_Pending..</span
          > -->
          <button
            @click="showPatientDetailsmodel(user.patient_id)"
            style="
              color: white;
              background-color: green;
              border: 1px solid white;
            "
            class="btn-xs font-weight-bold text-xs mb-1"
          >
            View patient</button
          >.

          <button
            @click="showTakeVitalsModal(user.id)"
            style="color: black; background-color: rgb(175, 225, 175)"
            class="btn-xs font-weight-bold text-xs"
          >
            Take Vitals
          </button>
        </td>
      </tr>
    </template>
  </BaseLayout>

  <ShowPatientModal
    v-if="showModalPatientDetailsModel"
    @close="handleClosePatientDetailsmodel"
    :patient_id="insearch_patient"
  />

  <TakeVitalsModal
    v-if="showModalTakeVitals"
    @close="handleCloseTakeVitalsModel()"
    :visit_id="insearch_visit"
  />
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex.js";
// import Pagination from '../components/pagination.vue';
import BaseLayout from "../Patients/components/table_page_layout.vue";
import ShowPatientModal from "../Patients/components/patient_details.vue";
import TakeVitalsModal from "../Patients/components/take_vitals_modal.vue";

//import axios from "axios";

export default {
  name: "triageindex",
  data() {
    return {
      users: [],
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search...",

      insearch_visit: "",
      showModalPatientDetailsModel: false,
      showModalTakeVitals: false,
      searchUrl: "search_get_all_gp_triage_queue",
      mainUrl: "get_all_gp_triage_queue",
    };
  },
  components: {
    BaseLayout,
    ShowPatientModal,
    TakeVitalsModal,
    // Search
  },

  methods: {
    handle_external_mount(payload) {
      this.users = payload;
    },

    showTakeVitalsModal(visit_id) {
      this.insearch_visit = visit_id;
      this.showModalTakeVitals = true;
    },
    handleCloseTakeVitalsModel() {
      this.showModalTakeVitals = false;
    },

    handleClosePatientDetailsmodel() {
      this.showModalPatientDetailsModel = false;
    },

    showPatientDetailsmodel(patient) {
      this.insearch_patient = patient;
      this.showModalPatientDetailsModel = true;
    },

    async callApi() {
      try {
        const url = "get_all_gp_triage_queue?page=1";
        const body = {};

        // const data = await getMethodRequest(url, body, 1);
        const data = await generalApiRequest(url, "GET", body, 1);
        console.log(data);
        this.allData = data.data;
        this.apiLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.callApi();
  },
};
</script>

<style scoped>
/* other */
.table-container {
  width: 100%;
}

.table {
  width: 100%;
  table-layout: fixed; /* Ensures the table width doesn't exceed the container */
}

.table th,
.table td {
  word-wrap: break-word; /* Allows text to wrap onto the next line */
  white-space: normal; /* Default behavior allows text to wrap */
  font-size: 0.8em;
  color: black;
  /* padding: 0; */
  margin: 0;
}
</style>
